import { getDarkThemeColor } from "../../Common/Appcommon";

export const CallVolumeChart = [
    {
        label: 'Calls Volume Analysis', 
        value: 'Won/Lost', 
        isHorizontal: true, 
        type: 'bar', 
        colordistributed: false, 
        tooltip: 'count',
        download : false, 
        operation: 'GET_CALL_VOLUME',
        dataLabel:true,
        height:"384%",
        width:"95%",
    }    
];

export const WinLoseChart = [
    {
        label: 'Won/Lost Analysis ', 
        value: 'Won/Lost', 
        isHorizontal: true, 
        type: 'bar', 
        colordistributed: false, 
        tooltip: 'count',
        download : false, 
        operation: 'GET_CALL_WIN_LOSS',
        dataLabel:true,
        height:"384%",
        width:"95%",
    }    
];

export const CallDurationTable = [
    {
        label: "Duration Analysis",
        operation: "FETCH_CALL_DURATION_STATS",
        columns: [
            {
                name: "Call Categories",
                selector: row => <strong>{row["duration"]}</strong>,
                sortable: false,
                width: '28%',
            },
            {
                name: "Calls",
                selector: row => row["calls"],
                sortable: false,
                width: '12%',
            },
            {
                name: "Minutes",
                selector: row => row["minutes"],
                sortable: false,
                width: '12%',
            },
            {
                name: "Average",
                selector: row => row["average"],
                sortable: false,
                width: '12%',
            },
            {
                name: "% of Calls",
                selector: row => row["percentageOfCalls"],
                sortable: false,
                width: '12%',
            },
            {
                name: "Goal Complete",
                selector: row => row["goalComplete"],
                sortable: false,
                width: '12%',
            },
            {
                name: "% of Goals",
                selector: row => row["percentageOfgoalComp"],
                sortable: false,
                width: '12%',
            },
        ],
    },
];


export const CallTypeOption = [
    { value: 'total_calls', label: 'All Calls' },
    { value: 'web_Call', label: 'Web Call' },
    { value: 'Inbound', label: 'Inbound' },
    { value: 'Outbound', label: 'Outbound' }
];

export const CallAnalyticsTypeOption = [
    {value: 'all_calls', label: 'All Calls'},
    { value: 'connected', label: 'Connected' },
    { value: 'not_connected', label: 'Not Connected' },
    { value: 'goal_complete', label: 'Goal Complete' },
    { value: 'goal_incomplete', label: 'Goal Incomplete' }
]

export const CallHeartMapChart = [
    {
        label: 'Heat Map', 
        type: 'heatmap', 
        colordistributed: false, 
        tooltipName: 'callHeatMap',
        toolbar : false, 
        operation: 'GET_HEAT_MAP_DATA',
        height:450,
        width:"100%",
        colorRange : [
            { from: 76, to: 100, color: getDarkThemeColor(), name: 'Above 75%', className: "theme-100p-color"},
            { from: 51, to: 75, color: '#046950', name: '51 to 75%', className: "theme-75p-color"},
            { from: 26, to: 50, color: '#058965', name: '26 to 50%', className: "theme-50p-color"},
            { from: 1, to: 25, color: '#06A57A', name: '1 to 25%', className: "theme-25p-color"},
            { from: -3, to: 0.09, color: '#07C392', name: 'No Calls (0%)', className: "theme-0-color"},
        ],
        analyticsLable:{
            "connected":"Total Calls vs Connected Calls",
            "not_connected":"Total Calls vs Not Connected Calls",
            "goal_complete":"Total Calls vs Goal Complete",
            "goal_incomplete":"Total Calls vs Goal Incomplete",
        }
    }    
];

export const ABTesting = [
    {
        label: "AB Testing",
        operation: "GET_ABTESTING_DETAILS",
        columns: ["Agent","AI Agent A","AI Agent B"], /*,"Winning %"*/
        subHeader : ['Calls','Goal','Call Duration','Call End Reason']
    }
];

export const filterOption1 = [
    {value : '1', lable: "Campaign"},
    {value : '2', lable: "Automation"},
  ];
  export const filterOption2 = [
    {value : '1', lable: "Connected"},
    {value : '2', lable: "Not Connected"},
    {value : '3', lable: "Goal Complete"},
    {value : '4', lable: "Goal Incomplete"},
  ];